<template>
  <div class="text-center">
    <v-dialog persistent v-if="visible" v-model="visible" width="800">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-pencil</v-icon>
            {{ edit ? "Editar" : "Cadastrar" }} FAQ
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-form ref="form">
          <v-row class="d-flex justify-center mt-7">
            <v-col cols="12">
              <v-text-field
                v-model="content.pergunta"
                label="Pergunta"
                outlined
                dense
                counter="300"
                maxlength="300"
                :rules="[(v) => $required(v), (v) => $max(v, 300), (v) => $min(v, 10)]"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="content.resposta"
                label="Resposta"
                outlined
                dense
                counter="2000"
                maxlength="2000"
                :rules="[(v) => $required(v), (v) => $max(v, 2000), (v) => $min(v, 10)]"
              ></v-textarea>
            </v-col>
            <v-col cols="12">
              <v-combobox
                  v-model="content.palavrasChave"
                  :items="[]"
                  chips
                  clearable
                  label="Palavras-Chave"
                  multiple
                  dense
                  persistent-hint
                  outlined
                >
                  <template v-slot:selection="{ attrs, item, select, selected }">
                    <v-chip
                      v-bind="attrs"
                      :input-value="selected"
                      close
                      class="ma-1"
                      small
                      @click="select"
                      @click:close="remover(item)"
                    >
                      <strong>{{ item }}</strong>&nbsp;
                    </v-chip>
                  </template>
                </v-combobox>
            </v-col>
          </v-row>
        </v-form>
        </div>
        <sca-buttons
          @click="salvar()"
          @cancel="$emit('onClose')"
          :actionText="edit ? 'Editar' : 'Salvar'"
        ></sca-buttons>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import { Faq } from '~/commons/classes/faq';
import FaqService from '~/services/faq.service';

export default {
  props: new DialogProps(Faq),
  mixins: [FaqService],
  methods: {
    salvar() {
      const save = () => {
        return this.$swal({
          text: `Deseja ${this.edit ? "editar" : "cadastrar"} o registro?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: `Confirmar`,
          cancelButtonText: `Cancelar`,
        }).then(() => {
          const faq = new Faq(this.content).format();
          return this.edit
            ? this.$editarFaq(faq, faq.id)
            : this.$cadastrarFaq(faq);
        });
      };
      if (this.$validarFormulario()) {
        save().then(({ data }) => {
          this.$notifySuccess(data.mensagem);
          this.$emit("onClose");
          this.$emit("onSave");
        });
      }
    },
    remover(palavraChave) {
      this.content.palavrasChave.splice(
        this.content.palavrasChave.indexOf(palavraChave),
        1
      );
    }
  },
};
</script>